<template>
  <div class="evaluation-criteria interview-general-container">
    <div class="rectangle" :class="[isModal ? 'p-0' : 'p-3']">
      <div class="d-flex align-items-center justify-content-between w-100" v-if="!isModal">
        <h3 class="interview-detail-h3">
          {{ resource["hrvenue.evaluationCriteriaLabel"] }}
        </h3>
        <h3 class="fw-500 mb-2" v-if="analyzeRight > 0">
          {{ totalCriteria }} / 7
        </h3>
      </div>
      <div class="evaluation-criteria__content" :style="{ 'margin-top': isModal ? '0' : '16px' }">
        <div class="evaluation-criteria__info">
          <i class="icon-awesome-two" />
          <p class="mb-0">
            {{ resource["hrvenue.evaluationCriteriaInfo"] }}
          </p>
        </div>
        <div class="evaluation-criteria__item">
          <div class="w-100">
            <div class="d-flex align-items-center justify-content-between w-100">
              <h4>
                {{ !analyzeRight ? resource["hrvenue.evaluationCriteriaSuggested"] : resource["hrvenue.evaluationCriteriaSpecific"] }}
              </h4>
              <h4 v-if="analyzeRight > 0 && isModal">
                {{ totalCriteria }} / 7
              </h4>
            </div>
            <span>{{ !analyzeRight ? resource["hrvenue.evaluationCriteriaSuggestedInfo"] : resource["hrvenue.evaluationCriteriaSpecificInfo"] }}</span>
          </div>
          <div class="evaluation-criteria__criterias">
             <!-- status: disabled, selected -->
              <template v-if="!criteriaLoading">
                <div
                  class="evaluation-criteria__criteria"
                  v-for="item in interview.criterias"
                  :key="item.criteriaId"
                  @click="!addOrUpdateCriteriaControl || !analyzeRight ? null : addCriteria(item)"
                  v-b-tooltip.hover.bottom="{ customClass: 'criteria-tooltip', delay: { show: 600, hide: 0 }, show: item.description }"
                  :title="item.description || ''"
                  :class="{ 'disabled': !addOrUpdateCriteriaControl || !analyzeRight, 'selected': interview.selectedCriteria?.find(criteria => criteria.criteriaId === item.criteriaId) }"
                >
                  <p>{{ item.name }}</p>
                  <i class="icon-add3" v-if="!interview.selectedCriteria?.find(criteria => criteria.criteriaId === item.criteriaId)" />
                  <i class="icon-close-rounded" v-else />
                </div>
              </template>
              <div v-if="criteriaLoading" class="evaluation-criteria__criterias">
                <b-skeleton animation="throb" width="108px" height="24px" style="border-radius: 50px; background: linear-gradient(90deg, #F1F1F1 0%, #E5E5E5 100%) !important;" v-for="i in 4" :key="i" />
              </div>
          </div>
          <div class="evaluation-criteria__specific-info" v-if="showJobSelectionInfo">
            <div class="d-flex align-items-center gap-2">
              <i class="icon-info" />
              <h4>{{ resource["hrvenue.evaluationCriteriaSelectJob"] }}</h4>
            </div>
            <button @click="checkAction('upgrade')">
              {{ resource["hrvenue.evaluationCriteriaSelectJobButton"] }}
            </button>
          </div>
        </div>
        <div class="evaluation-criteria__item" style="gap: 12px">
          <div>
            <h4>{{ resource["hrvenue.evaluationCriteriaLanguage"] }}</h4>
            <span>{{ resource["hrvenue.evaluationCriteriaLanguageInfo"] }}</span>
          </div>
          <div v-if="criteriaLoading" class="evaluation-criteria__language">
            <b-skeleton animation="fade" width="224px" height="24px" style="border-radius: 50px; background: linear-gradient(90deg, #F1F1F1 0%, #E5E5E5 100%) !important;"/>
          </div>
          <div v-else class="evaluation-criteria__language">
            <b-form-checkbox :id="'checkbox-language'" :key="'checkbox-language'"
              v-model="interview.isCheckedLanguageCheckBox"
              class="checkbox-2 checkbox-language"
              :disabled="!addOrUpdateCriteriaControl || !analyzeRight"
              :checked="Boolean(interview.selectedLanguages?.length > 0)"
              @change="handleLanguageCheckbox($event)"
            >
              {{ resource["questionLanguageText"] }}
            </b-form-checkbox>
            <div v-if="interview.isCheckedLanguageCheckBox && analyzeRight > 0" class="d-flex align-items-center ml-3">
              <b-dropdown :id="`evaluation-language-dropdown`"
                :class="['evaluation-language-dropdown', { 'is-error': interview.isCheckedLanguageDropdownError }]"
                :disabled="!addOrUpdateCriteriaControl"
              >
                <template #button-content>
                  <div :class="['evaluation-language-dropdown__button-content']">
                    <span v-if="!interview.selectedLanguages?.length">{{
                      resource["hrvenue.InterviewEdit.selectLanguage"] }}</span>
                    <span class="text-black" v-else>
                      <template v-for="(item, index) in interview.selectedLanguages">
                        {{languageItems.find(language => language.value === item.languageProficiency)?.title}}<template
                          v-if="index !== interview.selectedLanguages.length - 1">,</template>
                      </template>
                    </span>
                  </div>
                </template>
                <b-dropdown-item v-for="item in languageItems" :key="item.value">
                  <b-form-checkbox class="checkbox-item d-flex align-items-center cursor-pointer"
                    :key="`checkbox-${item.value}`"
                    :id="`checkbox-${item.value}`"
                    :checked="Boolean(interview.selectedLanguages?.find(criteria => criteria.languageProficiency === item.value))"
                    @change="addLanguageItem($event, item)"
                    @click.native.stop>
                    {{ item.title }}
                  </b-form-checkbox>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
        <div class="evaluation-criteria__info-area" v-if="!analyzeRight">
          <div class="d-flex align-items-center gap-2">
            <i class="icon-warning-outline" />
            <h4>{{ resource["hrvenue.evaluationCriteriaUpgrade"] }}</h4>
          </div>
          <router-link :to="{ name: 'PricingListView', params: { lang: $route.params.lang } }">
            {{ resource["hrvenue.evaluationCriteriaUpgradeButton"] }}
          </router-link>
        </div>
        <div class="evaluation-criteria__info-area is-modal" v-if="isModal">
          <div class="d-flex align-items-center gap-2">
            <i class="icon-warning-outline" />
            <h4>{{ resource["hrvenue.evaluationCriteriaModalInfo"] }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hrvenueService from '../../../services/hrvenue.service';
import { showNotification } from '../../../static/helpers';

export default {
  name: 'InterviewEvaluationCriteria',
  props: {
    interview: {
      type: Object,
      required: true,
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      analyzeRight: -1,
      addOrUpdateCriteriaControl: true,
      criteriaLoading: true,
      languageItems: [
        {
          id: 2, key: 'en', code: 'en-US', title: 'English', value: 'DEF917491852CF99',
        },
        {
          id: 1, key: 'tr', code: 'tr-TR', title: 'Türkçe', value: '825FD80875ADDE0B',
        },
        {
          id: 69, key: 'es', code: 'es-ES', title: 'Español', value: 'F3ACA5D2B90F4B81',
        },
        {
          id: 25, key: 'fr', code: 'fr-FR', title: 'Français', value: '5962CAAE6B0BCFC2',
        },
        {
          id: 27, key: 'de', code: 'de-DE', title: 'Deutsch', value: 'F5234C0737BFE469',
        },
      ],
    };
  },
  async created() {
    await this.getAnalyzeRight();
    try {
      this.criteriaLoading = true;
      if (this.addOrUpdateCriteriaControl && this.interview.selectedLanguages?.length === 0 && this.interview.selectedCriteria?.length === 0) {
        await this.getDefaultCriterias();
      }
      if (!this.isModal && this.interview?.id) {
        await this.getAddOrUpdateCriteriaControl();
      }
      if (this.interview?.id && this.interview.selectedLanguages?.length === 0 && this.interview.selectedCriteria?.length === 0) {
        await this.getInterviewCriterias();
      }

      if (this.addOrUpdateCriteriaControl) {
        const descriptionDifference = this.interview.tempJobDescription !== this.interview.jobDescription;
        const positionDifference = this.interview.position?.id !== this.interview?.tempPositionId;
        if (this.interview?.position?.id && (positionDifference || descriptionDifference)) {
          this.interview.selectedCriteria = this.interview.selectedCriteria.filter((criteria) => criteria.isInterviewCriteria);
          this.interview.criterias = this.interview.criterias.filter((criteria) => criteria.positionId !== this.interview.tempPositionId);
          this.interview.tempPositionId = this.interview.position?.id;
          this.interview.tempJobDescription = this.interview.jobDescription;
          await this.getGenerateCriterias();
        }
      }
      this.criteriaLoading = false;
    } catch (error) {
      this.criteriaLoading = false;
    }
  },
  computed: {
    totalCriteria() {
      return this.interview.selectedLanguages?.length + this.interview.selectedCriteria?.length;
    },
    showJobSelectionInfo() {
      return !this.criteriaLoading && this.addOrUpdateCriteriaControl && this.analyzeRight > 0 && !this.interview.position?.id && !this.interview.jobDescription;
    },
  },
  methods: {
    async getAddOrUpdateCriteriaControl() {
      const response = await hrvenueService.getAddOrUpdateCriteriaControl(this.interview.id);
      this.addOrUpdateCriteriaControl = response === true;
    },
    async getInterviewCriterias() {
      const response = await hrvenueService.getInterviewCriterias(this.interview.id);
      const languagesCriteria = response.filter((criteria) => criteria.languageProficiency);
      if (languagesCriteria.length > 0) {
        this.interview.selectedLanguages.push(...languagesCriteria);
        this.interview.isCheckedLanguageCheckBox = true;
      }
      const interviewCriteria = response
        .filter((criteria) => !criteria.languageProficiency)
        .map((criteria) => ({ ...criteria, isInterviewCriteria: true }));

      this.interview.selectedCriteria.push(...interviewCriteria);

      const aiGeneratedCriteria = response.filter((criteria) => criteria.isAiGenerated);
      if (aiGeneratedCriteria.length > 0) {
        this.interview.criterias.push(...aiGeneratedCriteria);
      }
    },
    async getDefaultCriterias() {
      const defaultCriteria = this.interview.criterias.filter((criteria) => criteria.isDefault);
      if (defaultCriteria.length > 0) {
        return;
      }
      const response = await hrvenueService.getDefaultCriterias();
      response?.forEach((responseCriteria) => {
        if (this.interview.criterias?.find((criteria) => criteria.criteriaId === responseCriteria.criteriaId)) {
          return;
        }
        this.interview.criterias.push({
          ...responseCriteria, isDefault: true, isInterviewCriteria: false, isAiGenerated: false,
        });
      });
    },
    async getGenerateCriterias() {
      const response = await hrvenueService.getGenerateCriterias(this.interview.position?.id, this.interview.jobDescription, null);
      response?.forEach((responseCriteria) => {
        if (this.interview.criterias?.find((criteria) => criteria.name?.toLowerCase()?.replace(/\s/g, '') === responseCriteria.name?.toLowerCase()?.replace(/\s/g, ''))) {
          return;
        }
        this.interview.criterias.push({
          ...responseCriteria, criteriaId: Math.random().toString(16).slice(2), isAiGenerated: true, positionId: this.interview.position?.id,
        });
      });
    },
    checkAction(val) {
      if (this.isModal) {
        const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;
        this.$router.push({
          name: 'InterviewEditView',
          params: { interviewId: this.interview.id, lang, step: 1 },
        });
        return;
      }
      this.$emit('check-action', val);
    },
    async getAnalyzeRight() {
      const response = await hrvenueService.getRight(4);
      this.analyzeRight = response?.totalUsableRight || 0;
    },
    handleLanguageCheckbox(event) {
      if (event) {
        this.interview.isCheckedLanguageDropdownError = false;
      } else {
        this.interview.selectedLanguages = [];
      }
      dataLayer.push({
        event: 'ga4_event',
        page_type: 'interview-create',
        site_type: 'interview',
        event_name: 'button_click',
        event_parameters: {
          button_name: 'language-proficiency',
          label: event ? 'true' : 'false',
        },
      });
    },
    showAddError() {
      showNotification(
        this.resource['Label.Error'],
        this.resource['hrvenue.evaluationCriteriaMaxError'],
        'error',
      );
    },
    addCriteria(item) {
      if (this.totalCriteria > 6 && !this.interview.selectedCriteria?.find((criteria) => criteria.criteriaId === item.criteriaId)) {
        showNotification(
          this.resource['Label.Error'],
          this.resource['hrvenue.evaluationCriteriaMaxError'],
          'error',
        );
        return;
      }
      if (this.interview.selectedCriteria?.find((criteria) => criteria.criteriaId === item.criteriaId)) {
        this.interview.selectedCriteria = this.interview.selectedCriteria?.filter((criteria) => criteria.criteriaId !== item.criteriaId);
      } else {
        const criteria = {
          id: item?.id || '',
          criteriaId: item?.criteriaId || '',
          isAiGenerated: item?.isAiGenerated || false,
          name: item?.name || '',
          description: item?.description || '',
          promptDescription: item?.promptDescription || '',
          languageProficiency: item?.languageProficiency || '',
        };
        this.interview.selectedCriteria?.push(criteria);
      }
    },
    addLanguageItem(event, item) {
      if (event && this.totalCriteria > 6) { // 7 için 6 yapmamız gerekiyor
        const checkboxElement = document.getElementById(`checkbox-${item.value}`);
        if (checkboxElement) {
          checkboxElement.checked = false;
        }
        showNotification(
          this.resource['Label.Error'],
          this.resource['hrvenue.evaluationCriteriaMaxError'],
          'error',
        );
        return;
      }

      if (event) {
        this.interview.isCheckedLanguageDropdownError = false;
        if (!this.interview.selectedLanguages.find((criteria) => criteria.languageProficiency === item.value)) {
          const criteria = {
            id: '',
            criteriaId: '',
            isAiGenerated: false,
            name: item.title,
            description: '',
            promptDescription: '',
            languageProficiency: item.value,
          };
          this.interview.selectedLanguages.push(criteria);
        }
      } else {
        this.interview.isCheckedLanguageDropdownError = false;
        const index = this.interview.selectedLanguages.findIndex((criteria) => criteria.languageProficiency === item.value);
        if (index !== -1) {
          this.interview.selectedLanguages = this.interview.selectedLanguages.filter((criteria) => criteria.languageProficiency !== item.value);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";

.interview-general-container {
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-bottom: 50px;
    margin-top: 32px;
  }
}

.evaluation-criteria {
  .interview-detail-h3{
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;

    @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
      margin-bottom: 16px !important;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: 200px;
  }

  &__info {
    background-color: #FAFAFA;
    position: relative;
    border-radius: 4px;
    display: flex;
    padding: 8px;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(to right,
          rgba(255, 241, 232, 1),
          /* #FFF1E8 ile opacity */
          rgba(240, 255, 253, 1)
          /* #F0FFFD ile opacity */
        );
      z-index: 1;
      border-radius: 4px;
    }

    p {
      color: #ff8d06 !important;
      font-family: Roboto;
      font-size: 12px !important;
      font-style: normal;
      font-weight: 700 !important;
      line-height: 18px !important;
      z-index: 2;
      margin-bottom: 0 !important;
    }

    i {
      color: #ff8d06 !important;
      font-size: 16px !important;
      z-index: 2;
    }
  }

  &__language {
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  &__info-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #FFEDB5;
    background: #FFF6DA;

    h4 {
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      color: #826300;
    }

    i {
      font-size: 20px;
      color: #826300;
    }

    a {
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      color: #826300;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    &.is-modal {
      position: absolute;
      bottom: 16px;
      left: 24px;
      width: calc(100% - 48px) !important;
      z-index: 2;
    }
  }

  &__specific-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #B7E1F3;
    background: #DBF0F9;

    h4 {
      font-family: Roboto;
      font-size: 12px !important;
      font-style: normal;
      font-weight: 400 !important;
      line-height: 18px !important;
      color: #114E67;
    }

    i {
      font-size: 20px !important;
      color: #114E67;
    }

    button {
      font-family: Roboto;
      font-size: 12px !important;
      font-style: normal;
      font-weight: 700 !important;
      line-height: 18px !important;
      color: #114E67;
      cursor: pointer;
      transition: all 0.3s ease;
      background: transparent;
      border: none;
      padding: 0;
      margin: 0;
      height: auto;
    }
  }

  &__item {
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    border-radius: 4px;
    background: #fafafa;

    h4 {
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      color: #333;
    }

    span {
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      color: #878787;
    }
  }

  &__criterias {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
  }

  &__criteria {
    display: flex;
    min-height: 24px;
    padding: 2px 8px;
    align-items: center;
    border-radius: 50px;
    border: 1px solid #E4E4E4;
    background: #FFF;
    cursor: pointer;
    transition: all 0.3s ease;

    &:not(.disabled):hover {
      border: 1px solid #FF8D06 !important;
    }

    &.disabled {
      cursor: not-allowed !important;
      pointer-events: auto !important;
      opacity: 1 !important;

      p,
      i {
        color: #AAA !important;
      }
    }

    &.selected {
      background: #FFF6E5 !important;
      border: 1px solid #FF8D06 !important;
      transition: all 0.3s ease;

      p,
      i {
        color: #ff8d06 !important;
      }
    }

    p {
      font-family: Roboto;
      font-size: 12px !important;
      font-style: normal;
      font-weight: 500 !important;
      line-height: 18px !important;
      color: #353535 !important;
      margin-bottom: 0 !important;
      margin-right: 4px !important;
    }

    i {
      color: #ff8d06 !important;
      font-size: 16px !important;
    }
  }
}

.criteria-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-right {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
      }
    }
  }

  &.bs-tooltip-left {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
        transform: rotate(180deg);
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 10px !important;

    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23E5E5E5"/></svg>') !important;
        width: 17px;
        height: 9px;
        bottom: 5px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    max-width: 530px !important;
    border: 1px solid var(--Stroke-Colors-Light-Blue-Stroke, #e5e5e5) !important;
    background: var(--Background-Colors-Light-Blue, #fff) !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6) !important;

    text-align: left;
    color: var(--Text-Colors-Blue-Text, #333) !important;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    /* 150% */
  }
}

.b-form-checkbox {
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #333333;
}

::v-deep {
  .evaluation-language-dropdown {
    width: 196px !important;
    height: 36px;

    &__button-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      box-orient: vertical;
      -webkit-box-orient: vertical;
      line-clamp: 1;
      -webkit-line-clamp: 1;

      .text-black {
        color: #333333 !important;

        .btn {
          color: #333333 !important;

          &:disabled {
            color: #AAA !important;
            cursor: not-allowed !important;
            pointer-events: auto !important;
          }
        }
      }

      span {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        color: #878787;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    &.is-error {
      .btn {
        border: 1px solid #DE4747 !important;
      }
    }

    &.show {
      .btn {
        border-radius: 4px;
        border: 1px solid #FF8D06;
        background: #FFF;
        box-shadow: 0 0 0 4px rgba(255, 141, 6, 0.30);
      }
    }

    .btn {
      width: 100%;
      height: 36px !important;
      display: flex;
      justify-content: space-between;
      border-radius: 4px;
      border: 1px solid #E5E5E5;
      background: #FFF;
      padding: 8px;
      color: #878787;
      font-feature-settings: 'liga' off, 'clig' off;
      text-overflow: ellipsis;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      /* 142.857% */

      &:after {
        color: #333333;
      }

      &:disabled {
        background-color: #e4e4e4 !important;
        color: #AAA !important;
        cursor: not-allowed;
        pointer-events: auto;
      }
    }

    .dropdown-menu {
      background-color: #ffffff !important;
      width: 100%;
      top: 8px !important;
      @include border-radius(4px);
      border: 1px solid #E5E5E5;
      box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
      padding: 4px 8px;

    }

    .dropdown-item {
      color: #333333 !important;
      text-transform: capitalize;
      padding: 6px 8px !important;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      &:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      &:hover {
        background-color: #EEEEEE !important;
        color: #333333 !important;
      }
    }
  }

  .checkbox-item {
    .custom-control-label {
      cursor: pointer;
      color: #333 !important;
      font-feature-settings: "liga" off, "clig" off;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px !important;
      padding: 2px !important;

      &:hover {
        &::after {
          background: #ffe9ce;
        }
      }

      &::after {
        border: 1px solid #333;
        border-radius: 2px;
      }

      &::before {
        border-color: transparent !important;
        outline: none;
        box-shadow: none;
        width: 16px !important;
        height: 16px !important;
      }
    }

    &.disabled {
      .custom-control-label {
        cursor: not-allowed !important;
        pointer-events: auto !important;
        color: #AAA !important;

        &:hover {
          &::after {
            background: transparent !important;
          }
        }

        &::after {
          border: 1px solid #AAA !important;
        }
      }
    }

    .custom-control-input {
      cursor: pointer;

      &:focus {
        border-color: transparent !important;
        outline: none !important;
        box-shadow: none !important;

        &~.custom-control-label::before {
          outline: none !important;
          box-shadow: none !important;
        }
      }

      &:checked {
        &~.custom-control-label {
          &::before {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.86337 10.5836L3.55004 8.27026C3.29004 8.01026 2.87004 8.01026 2.61004 8.27026C2.35004 8.53026 2.35004 8.95026 2.61004 9.21026L5.39671 11.9969C5.65671 12.2569 6.07671 12.2569 6.33671 11.9969L13.39 4.94359C13.65 4.68359 13.65 4.26359 13.39 4.00359C13.13 3.74359 12.71 3.74359 12.45 4.00359L5.86337 10.5836Z" fill="white"/></svg>') !important;
            color: $white !important;
            background: $purple !important;
            font-size: 14px;
            text-align: center;
            position: absolute;
            left: -25px;
            border-radius: 2px;
          }

          &::after {
            display: none !important;
          }
        }
      }
    }
  }

  .checkbox-language {
    &:has(input:disabled) {
      cursor: not-allowed !important;
      pointer-events: auto !important;

      label {
        color: #AAA !important;
        cursor: not-allowed !important;
        pointer-events: auto !important;
      }

      .custom-control-input {
        cursor: not-allowed !important;
        pointer-events: auto !important;
      }
    }

    label {
      padding-left: 4px !important;
      color: #333333 !important;
    }

    .custom-control-input {
      &:checked {
        &~.custom-control-label {
          &::before {
            content: "\E925" !important;
            color: $white !important;
            background: $purple !important;
            font-size: 14px;
            text-align: center;
            position: absolute;
            left: -22px;
          }
        }
      }

      &:disabled {
        &~.custom-control-label {
          color: #C3C3C3 !important;

          &::before {
            border-color: #C3C3C3 !important;
            opacity: 1 !important;
          }
        }
      }
    }
  }
}
</style>
